<template>
  <div>
    <div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата</label>
            <el-date-picker
              v-model="dateFrom"
              input-id="date-from"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата</label>
            <el-date-picker
              v-model="dateTo"
              input-id="date-to"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев</label>
            <input type="text" class="form-control" v-model="months">
          </div>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 25px;" class="text-right">
            <a class="btn btn-primary" href="#" @click.prevent="printBill">напечатать квитанцию</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Начальная дата 2</label>
            <el-date-picker
              v-model="dateFrom2"
              input-id="date-from2"
              input-class="form-control"
              type="date"
              placeholder="Начальная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Конечная дата 2</label>
            <el-date-picker
              v-model="dateTo2"
              input-id="date-to2"
              input-class="form-control"
              type="date"
              placeholder="Конечная дата 2">
            </el-date-picker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Количество месяцев 2</label>
            <input type="text" class="form-control" v-model="months2">
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label>Актуальный баланс</label>
            <input type="text" class="form-control" v-model="newBalance">
          </div>
        </div>
        <div class="col-md-3">
          <div style="margin-top: 25px;" class="text-right">
            <a class="btn btn-primary" href="#" @click.prevent="drawBalance">свести баланса</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Адрес</label>
          <p>{{ client.full_name }}</p>
        </div>

        <!-- First name -->
        <div class="form-group">
          <label>Имя</label>
          <p>{{ client.first_name }}</p>
        </div>

        <!-- Middle name -->
        <div class="form-group">
          <label>Отчество</label>
          <p>{{ client.middle_name }}</p>
        </div>

        <!-- Last name -->
        <div class="form-group">
          <label>Фамилия</label>
          <p>{{ client.last_name }}</p>
        </div>

      </div>
      <div class="col-md-6">

        <!-- Balance -->
        <div class="form-group">
          <label>Баланс</label>
          <p>{{ toMoney(client.balance) }}</p>
        </div>

        <!-- Phone -->
        <div class="form-group">
          <label>Телефон</label>
          <p>{{ client.phone }}</p>
        </div>

        <!-- Contract number -->
        <div class="form-group">
          <label>Номер договора</label>
          <p>{{ client.contract_number }}</p>
        </div>

        <!-- Rate plan info -->
        <div v-if="rate_plan.id" class="form-group">
          <label>Информация о тарифном плане</label>
          <p>"{{ rate_plan.name }}" - {{ toMoney(rate_plan.amount) }}</p>
        </div>

        <!-- Discount info -->
        <div v-if="discount.id" class="form-group">
          <label>Информация о скидке</label>
          <p>"{{ discount.name }}" - {{ toMoney(discount.amount) }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :client-id="client.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getClient, applyRatePlan, printBill, drawBalance } from '@/services/client.service'
import { getRatePlan } from '@/services/rate_plan.service'
import { getDiscount } from '@/services/discount.service'
import helpers from '@/helpers'

export default {
  name: 'client-detail',
  props: {
    clientId: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      months: '',
      dateFrom: '',
      dateTo: '',
      months2: 1,
      dateFrom2: null,
      dateTo2: null,

      newBalance: '',

      client: {
        id: null,
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        contract_number: '',
        full_name: '',
        rate_plan: '',
        balance: ''
      },
      rate_plan: {
        id: null,
        name: '',
        amount: '',
        period: '',
        start_date: '',
        end_date: ''
      },
      discount: {
        id: null,
        name: '',
        amount: ''
      }
    }
  },
  mounted () {
    this.loadClient()
  },
  methods: {
    toMoney: helpers.toMoney,
    formatDate: helpers.formatDate,

    loadClient () {
      if (this.clientId !== undefined) {
        this.client.id = this.clientId

        getClient(this.client.id).then((response) => {
          this.client = response.data

          getRatePlan(this.client.rate_plan).then((response) => {
            this.rate_plan = response.data
          })

          getDiscount(this.client.discount).then((response) => {
            this.discount = response.data
          })
        })
      }
    },
    applyRatePlan () {
      applyRatePlan(this.client.id).then((response) => {
        this.showMsg('История оплат была успешно сгенерирована!', 'success', 'Успех')
      }).catch(err => {
        console.log(err)
        this.showMsg('Возникла непредвиденная ошибка!', 'error', 'Ошибка')
      })
    },
    drawBalance () {
      drawBalance(this.client.id, this.newBalance).then((response) => {
        this.showMsg('Баланс был успешно сведен', 'success', 'Успех')
        this.loadClient()
      }).catch(err => {
        console.log(err)
        this.showMsg('Возникла ошибка!', 'error', 'Ошибка')
      })
    },
    printBill () {
      let dateFrom
      let dateTo
      let dateFrom2
      let dateTo2

      if (this.dateFrom) {
        dateFrom = this.dateFrom.toJSON()
      } else {
        dateFrom = this.dateFrom
      }
      if (this.dateTo) {
        dateTo = this.dateTo.toJSON()
      } else {
        dateTo = this.dateTo
      }

      if (this.dateFrom2) {
        dateFrom2 = this.dateFrom2.toJSON()
      } else {
        dateFrom2 = this.dateFrom2
      }
      if (this.dateTo2) {
        dateTo2 = this.dateTo2.toJSON()
      } else {
        dateTo2 = this.dateTo2
      }

      printBill(this.client.id, this.months, dateFrom, dateTo, this.months2, dateFrom2, dateTo2).then((response) => {
        let file = new Blob([response.data], {type: 'application/pdf'})
        let fileURL = URL.createObjectURL(file)
        window.open(fileURL)
      }).catch(err => {
        console.log(err)
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientDetail.vue?b982f94e